// src/stone/icons/Award.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Award = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsxs("g", { fill: "currentcolor", children: [
      /* @__PURE__ */ jsx("path", { d: "M12 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12M4 8a8 8 0 1 1 16 0A8 8 0 0 1 4 8" }),
      /* @__PURE__ */ jsx("path", { d: "M15.659 12.89a1 1 0 0 1 1.122.86l1.21 9.12a1 1 0 0 1-1.506.988L12 21.168l-4.485 2.69a1 1 0 0 1-1.506-.989l1.21-9.11a1 1 0 0 1 1.982.264l-.937 7.053 3.222-1.933a1 1 0 0 1 1.028 0l3.222 1.933-.937-7.064a1 1 0 0 1 .86-1.122" })
    ] })
  }
);
var Award_default = Award;

export {
  Award_default
};
